const Redirect = require('./redirect');

const LOGIN_PAGE = '/login';
const CALC_PAGE = '/calc';
const CALC2_PAGE = '/calc2';
const TRACKING_PAGE = '/tracking';

function isOnPage(page) {
    var curPage = Redirect.getCurrentUrl();
    var argsStartIndex = curPage.indexOf('?');
    if (argsStartIndex > 0) {
        curPage = curPage.substr(0, argsStartIndex);
    }
    while (curPage.endsWith('/')) {
        curPage = curPage.substr(0, curPage.length - 1);
    }
    return curPage.endsWith(page);
}

function isOnLoginPage() {
    return isOnPage(LOGIN_PAGE);
}

function isOnCalcPage() {
    return isOnPage(CALC_PAGE) || isOnPage(CALC2_PAGE);
}

function isOnTrackingPage() {
    return isOnPage(TRACKING_PAGE);
}

function isAnonymousAllowed() {
    return isOnLoginPage() || isOnCalcPage() || isOnTrackingPage();
}

function stopSession(needLogout) {
    window.jivo_api && window.jivo_api.clearHistory();

    if (needLogout) {
        redirectToLogout();
    } else {
        redirectToLogin();
    }
}

module.exports = {
    isOnLoginPage: isOnLoginPage,
    isAnonymousAllowed: isAnonymousAllowed,
    stopSession: stopSession
};


// WEBPACK FOOTER //
// ./App/services/session.js